import { useState, useEffect } from 'react';

const STEPS = [
  { title: 'Welcome to What\'s NEXT', desc: 'The most comprehensive hospitality business health audit platform. Let\'s walk through the key features.', target: null },
  { title: 'Create Your First Audit', desc: 'Click "New Audit" to start. Enter the concept name, city, website, and Instagram. Upload financials or menus if you have them.', target: 'New Audit' },
  { title: '3-Step AI Research', desc: 'Step 1: AI finds competitors. Step 2: Research the market with real Google data. Step 3: AI scores all 10 pillars using real reviews and Instagram metrics.', target: 'AI Steps' },
  { title: 'Score the 10 Pillars', desc: 'Each pillar has a slider (0-10), AI research, and your team rationale. Confidence and evidence labels track data quality.', target: 'Pillars' },
  { title: 'Guest Journey', desc: '35+ touchpoints from discovery to departure. Score each manually or let AI research the digital touchpoints.', target: 'Guest Journey' },
  { title: 'Deep Dives', desc: 'Memory Test, Menu Trends, Social Proof, Brand Coherence, Photos, Notes, Revenue Leaks, and Menu Item Scoring — all in one tab.', target: 'Deep Dives' },
  { title: 'Intelligence', desc: 'Competitive Radar, Kill Sheet, Sentiment Analysis, Risk Radar, Signature Moments, Seasonality, and Benchmarking.', target: 'Intelligence' },
  { title: 'Revenue & Labor', desc: 'Calculate Revenue Per Seat Per Hour, staff ratios, and map revenue by day and hour.', target: 'Revenue & Labor' },
  { title: 'Share with Clients', desc: 'Click "Share" for a public link, "Report" for the full view with section checkboxes, or "Exec Summary" for a 1-page PDF.', target: 'Share' },
  { title: 'You\'re Ready', desc: 'Start your first audit. The AI will handle the research — you bring the hospitality expertise.', target: null },
];

export default function Onboarding({ onComplete }) {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;
  const pct = ((step + 1) / STEPS.length) * 100;

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center px-4">
      <div className="card p-8 max-w-md w-full text-center">
        {/* Progress */}
        <div className="h-1 bg-neutral-800 rounded-full overflow-hidden mb-6">
          <div className="h-full bg-brand-gold rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
        </div>

        <div className="mb-6">
          <img src="https://static.wixstatic.com/media/cf458d_f7329a8f179a4571a1951c4ed9431604~mv2.png" alt="NE" className="h-10 w-auto mx-auto mb-4" />
          <h2 className="font-display text-xl text-white mb-3">{current.title}</h2>
          <p className="text-sm text-neutral-400 leading-relaxed">{current.desc}</p>
        </div>

        <div className="flex items-center justify-between">
          <button onClick={() => step > 0 && setStep(step - 1)} className={`btn-ghost text-xs ${step === 0 ? 'invisible' : ''}`}>Back</button>
          <span className="text-[10px] text-neutral-600">{step + 1} / {STEPS.length}</span>
          {isLast ? (
            <button onClick={onComplete} className="btn-primary text-xs">Get Started</button>
          ) : (
            <button onClick={() => setStep(step + 1)} className="btn-primary text-xs">Next</button>
          )}
        </div>

        <button onClick={onComplete} className="text-[10px] text-neutral-600 hover:text-neutral-400 mt-4 block mx-auto">Skip walkthrough</button>
      </div>
    </div>
  );
}

// Check if user has seen onboarding
export function shouldShowOnboarding() {
  return !localStorage.getItem('whats_next_onboarded');
}

export function markOnboarded() {
  localStorage.setItem('whats_next_onboarded', 'true');
}
